import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Icon, Image, Menu, Segment, TextArea } from 'semantic-ui-react';
import PageContainer from './../common/PageContainer';
import * as selectors from './../../redux/selectors';
import * as actions from './../../redux/actions';
import { bindActionCreators } from 'redux';
import { TextField } from './../common/FormFields';
import { Formik } from 'formik';
import { userValidationSchema } from './../admin/admin.constants';
import CloudinaryUploadWidget from './../showcase/CloudinaryUploadWidget';
import * as userApi from './../../api/userApi';

export const UserProfilePage = ({ user, updateUser }) => {
  const [rebelmouseSites, setRebelmouseSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    userApi.getUserById(user.id).then(setCurrent);
    setRebelmouseSites([]);
  }, []);

  useEffect(() => {
    if (!user?.email || rebelmouseSites?.length) return;
    userApi
      .getRebelMouseRoles(user?.email)
      .then(setRebelmouseSites)
      .catch(console.log)
      .finally(() => setLoading(false));
  }, [user]);

  const handleSubmit = formik => {
    console.log('submit', formik);
    updateUser(current);
    formik.setSubmitting(false);
  };

  const getMenu = formik => (
    <Menu borderless attached="top">
      <Menu.Item header>
        <Icon name="user circle outline" />
        {user.name}
      </Menu.Item>

      <Menu.Menu position="right">
        <Menu.Item>
          <Button
            icon="save"
            positive
            content="Save"
            disabled={!formik.isValid || formik.isSubmitting}
            text="Save changes"
            onClick={() => formik.handleSubmit(formik)}
          />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );

  const getUserForm = formik => (
    <Segment attached>
      <Form onSubmit={formik.handleSubmit}>
        <br />
        <Form.Group widths="2">
          <TextField
            name="email"
            label="Email"
            formik={formik}
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            errorMessage={formik.errors.email}
          />
          <TextField
            name="name"
            label="Name"
            formik={formik}
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            errorMessage={formik.errors.name}
          />
        </Form.Group>

        <br />

        <Form.Field>
          <label>Bio</label>
          <TextArea value={formik.values.bio} onChange={(e, { value }) => formik.setFieldValue('bio', value)} />
        </Form.Field>

        <br />
        <br />

        <>
          <strong>Profile Photo</strong>
          <div>
            <Image
              size="tiny"
              avatar
              src={formik.values.imageUrl || 'https://react.semantic-ui.com/images/wireframe/square-image.png'}
            />
            <br />
            <br />
            <CloudinaryUploadWidget formik={formik} fieldName="imageUrl" onSuccess={formik.handleSubmit} />
          </div>
        </>
      </Form>
    </Segment>
  );

  const getUserPage = () => {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={current}
        validationSchema={userValidationSchema}
        onSubmit={handleSubmit}
      >
        {formik => (
          <>
            {getMenu(formik)}

            {getUserForm(formik)}
          </>
        )}
      </Formik>
    );
  };

  return <PageContainer>{current && current?.id && getUserPage()}</PageContainer>;
};

const mapStateToProps = state => ({
  user: selectors.users.current(state),
});

const mapDispatchToProps = dispatch => ({
  setUser: bindActionCreators(actions.admin.setUser, dispatch),
  updateUser: bindActionCreators(actions.admin.updateUser, dispatch),
  removeUserRole: bindActionCreators(actions.admin.removeUserRole, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfilePage);
